import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, Phone, ChevronRight } from 'lucide-react';

const LINKS = [
  { to: '/catalogue', label: 'Notre catalogue de location' },
  { to: '/devis', label: 'Demander un devis gratuit' },
  { to: '/blog', label: 'Nos guides événementiels' },
  { to: '/faq', label: 'Questions fréquentes' },
];

const NotFoundPage = () => (
  <div className="min-h-screen bg-gray-50 pt-24" data-testid="not-found-page">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
      <p className="text-sm font-semibold uppercase tracking-widest text-orange-500 mb-4">Erreur 404</p>
      <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-5">Cette page n'existe pas</h1>
      <p className="text-base text-gray-600 max-w-xl mx-auto mb-10">
        Le lien est peut-être erroné ou la page a été déplacée. Retrouvez ci-dessous l'essentiel du site
        Barnum Événement, ou contactez-nous directement : nous répondons vite.
      </p>

      <div className="flex flex-wrap justify-center gap-3 mb-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 transition-colors"
          data-testid="notfound-home-link"
        >
          <Home className="w-4 h-4" /> Retour à l'accueil
        </Link>
        <a
          href="tel:+33623893298"
          className="inline-flex items-center gap-2 px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-full hover:border-orange-400 hover:text-orange-600 transition-colors"
          data-testid="notfound-phone-link"
        >
          <Phone className="w-4 h-4" /> 06 23 89 32 98
        </a>
      </div>

      <div className="bg-white rounded-2xl shadow-sm p-8 text-left">
        <h2 className="flex items-center gap-2 text-base md:text-lg font-semibold text-gray-900 mb-4">
          <Search className="w-4 h-4 text-orange-500" /> Pages les plus consultées
        </h2>
        <ul className="divide-y divide-gray-100">
          {LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className="flex items-center justify-between py-3 text-sm text-gray-700 hover:text-orange-600 transition-colors"
                data-testid={'notfound-link-' + link.to.replace('/', '')}
              >
                {link.label}
                <ChevronRight className="w-4 h-4 text-gray-300" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
